package com.yendo.mx.models

import kotlinx.serialization.Serializable
import dev.gitlive.firebase.firestore.GeoPoint // 🚀 Importación para GeoPoints en KMP

/**
 * Representa el "Portero" de una zona de operación.
 * Se utiliza para validar si un cliente tiene cobertura antes de permitirle comprar.
 */
@Serializable
data class ZonaDirectorio(
    val id_zona: String = "",
    val nombre_mostrable: String = "",
    val status: String = "activo",
    val codigos_postales: List<String> = emptyList(),
    val ciudades_alias: List<String> = emptyList(),

    // 🚀 Lista de "islas" de servicio (Centro, Cobach, etc.)
    val poligonos_servicio: List<PoligonoWrapper> = emptyList(),

    // 🚀 Lista de áreas prohibidas (Zonas rojas o bloqueos temporales)
    val poligonos_exclusion: List<PoligonoWrapper> = emptyList(),

    // Configuración visual opcional para el mapa
    val ui_mapa: UiMapaZona = UiMapaZona()
)

/**
 * Clase envoltorio (Wrapper) necesaria para evitar el error de Firestore
 * al intentar guardar arreglos anidados (Arrays dentro de Arrays).
 */
@Serializable
data class PoligonoWrapper(
    val coordenadas: List<GeoPoint> = emptyList()
)

/**
 * Datos de diseño para dibujar los polígonos en el mapa de administrador.
 */
@Serializable
data class UiMapaZona(
    val fillColorAlpha: Double = 0.21,
    val fillColorHex: String = "#E91E63",
    val strokeColorAlpha: Double = 0.2,
    val strokeColorHex: String = "#C2185B",
    val strokeWidth: Int = 3
)